import { render, staticRenderFns } from "./withPerPage.vue?vue&type=template&id=6473903e&scoped=true"
import script from "./withPerPage.vue?vue&type=script&lang=js"
export * from "./withPerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473903e",
  null
  
)

export default component.exports